import { render } from "./inputValidateNumeric.vue?vue&type=template&id=be0e4f96&lang=pug"
import script from "./inputValidateNumeric.vue?vue&type=script&lang=js"
export * from "./inputValidateNumeric.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__